module.exports = __webpack_public_path__ + "bg-greetings-1430w--9eef01a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/header/bg-greetings-1430w.jpg
// module id = 114
// module chunks = 0